import * as React from "react"
export const QuoteHero = () => {
  return (
    <div className="py-20">
      <div className="container mx-auto flex flex-col items-center">
        <div className="lg:w-1/2 text-center px-3 lg:px-1">
          <h1 className="lg:text-4xl text-lg !leading-relaxed text-black font-semibold">
            What does your Partner need <br /> to get{" "}
            <span className="text-gradient-secondary">Started Working</span>{" "}
            with you 😍
          </h1>
        </div>
      </div>
    </div>
  )
}
